import { useEffect, useState } from "react";
import { IoChevronBackOutline } from "react-icons/io5";
import { ProductCards } from "../ProductCards/ProductCards";
import { useTranslation } from "react-i18next";
import { useAmplitude } from "../../../context/AmplitudeContext";
import { useUID } from "../../../context/UIDContext";
import Pagination from "../../Pagination/Pagination";
import { ProductsPerPage } from "../../../constants";
import { useConfig } from "../../../context/ConfigContext";
import "./ProductPage.scss";
import { ProductInfoModalCard } from "../ProductInfoModalCard/ProductInfoModalCard";
import { ProductFilterDropdown } from "../ProductFilterDropDown/ProductFilterDropDown";
import { HowItWorks } from "./HowItWorks";
import { useTracker } from "../../../context/TrackerContext";

export const ProductPage = ({ recommendedData, onBackClick }) => {
  const { t } = useTranslation("productModule");
  const trackEvent = useAmplitude();
  const { itrack } = useTracker();
  const { uid } = useUID();
  const { logo, configData } = useConfig();
  const [moreInfoProduct, setMoreInfoProduct] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);

  const [selectedCategory, setSelectedCategory] = useState("All-Categories");
  const [selectedBrand, setSelectedBrand] = useState("All-Brands");
  const [filteredProducts, setFilteredProducts] = useState(
    recommendedData.recommendations ?? [],
  );

  const getPaginatedProducts = () => {
    if (filteredProducts) {
      const startIndex = (currentPage - 1) * ProductsPerPage;
      const endIndex = startIndex + ProductsPerPage;
      const paginated = filteredProducts.slice(startIndex, endIndex);
      return paginated;
    }
    return [];
  };

  const paginatedProducts = getPaginatedProducts();

  useEffect(() => {
    trackEvent("webapp_user_visited_products_page", uid);
    itrack({
      eventName: "visited_products_page",
      trackerId: uid,
    });
  }, [uid, trackEvent, itrack]);

  useEffect(() => {
    const filteredProducts = recommendedData.recommendations.filter(
      (product) =>
        (selectedCategory === "All-Categories" ||
          product.categories.includes(selectedCategory)) &&
        (selectedBrand === "All-Brands" || product.brand === selectedBrand),
    );
    setCurrentPage(1);
    setFilteredProducts(filteredProducts);
  }, [recommendedData.recommendations, selectedCategory, selectedBrand]);

  return (
    <div className="product-recommend">
      <div className="logo-bar">
        <div className="products-back-button-wrapper">
          <IoChevronBackOutline
            className="back-icon"
            onClick={() => onBackClick()}
          />
        </div>
        {configData?.ProductModuleFlags?.logoEnabled !== false ? (
          <img
            className="logo-img"
            src={
              configData?.ProductModuleFlags?.logoUrl
                ? configData?.ProductModuleFlags?.logoUrl
                : logo
            }
            alt="Logo"
          />
        ) : null}
      </div>
      <div className="recommendation-scroll-content">
        <div className="product-page_header">
          <h4 className="products-page-info">{t("title-1")}</h4>
          <h4 className="products-page-info">{t("title-2")}</h4>
          {configData?.ProductModuleFlags?.version === "2.0.0" &&
            recommendedData.recommendations &&
            recommendedData.recommendations.length > 0 && (
              <HowItWorks products={recommendedData.recommendations} />
            )}
        </div>
        <div className="filter-wrapper">
          {/* Category Filter */}
          {recommendedData.categories &&
            recommendedData.categories.length > 1 && (
              <ProductFilterDropdown
                selectedValue={selectedCategory}
                onUpdateValue={(selectedValue) =>
                  setSelectedCategory(selectedValue)
                }
                allValues={["All-Categories", ...recommendedData.categories]}
                side="left"
              />
            )}

          {/* Brand Filter */}
          {recommendedData.brands && recommendedData.brands.length > 1 && (
            <ProductFilterDropdown
              selectedValue={selectedBrand}
              onUpdateValue={(selectedValue) => setSelectedBrand(selectedValue)}
              allValues={["All-Brands", ...recommendedData.brands]}
              side={
                recommendedData.categories &&
                recommendedData.categories.length > 1
                  ? "right"
                  : "left"
              }
            />
          )}
        </div>

        {/* Products */}
        <div className="products-wrapper">
          {paginatedProducts.length > 0 ? (
            <ProductCards
              products={paginatedProducts}
              onShowMoreClick={(product) => setMoreInfoProduct(product)}
            />
          ) : (
            <div className="not-found-container">
              <h4 className="not-found-header">{t("not-found-header")}</h4>
              <p className="not-found-text">{t("not-found-text")}</p>
            </div>
          )}
        </div>

        {/* Pagination */}
        {filteredProducts.length > ProductsPerPage && (
          <Pagination
            currentPage={currentPage}
            totalPages={
              ProductsPerPage > 0
                ? Math.ceil(filteredProducts.length / ProductsPerPage)
                : 1
            }
            onPageChange={(page) => setCurrentPage(page)}
          />
        )}
      </div>

      <ProductInfoModalCard
        infoData={moreInfoProduct}
        isOpen={moreInfoProduct !== null}
        onClose={() => setMoreInfoProduct(null)}
      />
    </div>
  );
};
